import { IOption } from "src/pages/projects/project/components/account-information/types";

const getFiltersASCByName = (filters: IOption[]): IOption[] => {
  return filters.sort((a, b) => a.label.localeCompare(b.label));
};

export default getFiltersASCByName;
